import { BulkSignOrchestratorApiTypes } from "@rshbintech.dboul/http";
import { DOCUMENT_SIGNING_ERROR, DOCUMENT_SIGNING_STAGES } from "../constants";
import { Document, SignedDocument } from "../types";

// Сопоставляет полученные ККБ с документами на подписание
// Возвращает массив документов с полученными ККБ
export const matchCcb = (
  documents: Document[],
  ccbDataList: BulkSignOrchestratorApiTypes.CcbData[]
): SignedDocument[] => {
  const documentsWithCcb: SignedDocument[] = [];

  ccbDataList.forEach((ccbInfo) => {
    const document = documents.find((document) => document.id === ccbInfo.id);

    if (document) {
      const documentWithCcb: SignedDocument = {
        ...document,
        signatureInfo: {
          ccbInfo: ccbInfo || null,
          signature: "",
          error: ccbInfo ? "" : DOCUMENT_SIGNING_ERROR,
          signingStage: ccbInfo ? DOCUMENT_SIGNING_STAGES.GOT_CCB : null,
        },
        documentStatus: {
          status: "",
          errorText: "",
        },
        systemShortName: document.systemShortName || "",
      };

      documentsWithCcb.push(documentWithCcb);
    }
  });

  return documentsWithCcb;
};
